/* @flow */
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Translate, I18n } from 'react-redux-i18n'
import _ from 'lodash'

import './style.css'
import Map from '../../components/Map'
import Checkbox from '../../components/Checkbox'
import Card from '../../components/Card'
import CompoundInput from '../../components/CompoundInput'
import Header from '../../components/Header'
import { setViewScene } from '../../actions/scene'
import { setViewShop } from '../../actions/shop'
import { show360, search } from '../../actions/global'
import { divingServices, otherServices } from '../../configs/constants'
import Preview from '../../components/Preview';

class MapMode extends React.Component {
  elem

  constructor(props) {
    super(props)
    this.state = {
      divingMode: true,
      isAccordionOpen: false,
      filtered: [],
      filteredShops: props.shops || [],
      filterParams: [],
      filterOtherParams: [],
      selected: '',
      selectedShop: null,
      showAed: false
    }
  }

  componentDidUpdate() {
    if (!this.props.scene.length && this.props.locations.length) {
      this.props.setViewScene(this.props.locations)
    }
    if (this.props.allShops.length && !this.state.filteredShops.length && !this.state.filterParams.length) {
      this.setState({ filteredShops: this.props.allShops})
    }
  }

  toggleAccordion() {
    this.setState({ isAccordionOpen: !this.state.isAccordionOpen })
  }

  filterList(list, params, otherParams) {
    return _.filter(_.filter(list, (item) => _.difference(params, item.services).length === 0),
      (item) => _.difference(otherParams, item.otherServices).length === 0
    )
  }

  render() {
    const scene = this.props.scene.length && this.props.scene[0]
    const { locations, allShops, search, locale, activities, filteredActivities, navigate, show360 } = this.props
    const { isAccordionOpen, divingMode, filtered, filteredShops, filterParams, filterOtherParams, selectedShop, showAed } = this.state

    const sceneName = scene.name && scene.name[locale]
    const filteredDisplayActivities = _.filter(filteredActivities, (activity) => _.find(filteredShops, (shop) => shop.id === activity.shopId))

    return <div className="map-container">
      <CompoundInput
        dataList={locations}
        displayFields={"name." + locale}
        placeholder={sceneName || I18n.t('searchPlaceholder')}
        submitText="search"
        submit={(location, startDate, endDate, experience) => {
          this.setState({ divingMode: false, selectedShop: null })
          search(location, startDate, endDate, experience)
        }} />
      <div className={'search-container search-wrapper clickable' + (isAccordionOpen ? ' open' : '')}>
        <Header
          title="filter"
          onClick={(e) => {
            e.preventDefault()
            this.toggleAccordion()
          }}
          togglable
        />
        <Card
          header={<Translate value="divingServices" className="headline headline-light" />}>
          <ul>
          { _.map(divingServices, (service) =>
            <li key={service}>
              <label>
                <Checkbox className="caerulus"
                  onChange={(checked) => {
                    if (checked) {
                      const params = [...filterParams, service]
                      this.setState({
                        filterParams: params,
                        filteredShops: this.filterList(allShops, params, filterOtherParams),
                        selectedShop: null,
                      })
                    } else {
                      const params = [...filterParams]
                      params.splice(filterParams.indexOf(service), 1)
                      this.setState({
                        filterParams: params,
                        filteredShops: this.filterList(allShops, params, filterOtherParams),
                        selectedShop: null,
                      })
                    }
                  }}
                />
                <Translate value={service} />
              </label>
            </li>
          ) }
          </ul>
        </Card>
        <Card
          header={<Translate value="otherServices" className="headline headline-light" />}>
          <ul>
          { _.map(otherServices, (service) =>
            <li key={service}>
              <label>
                <Checkbox className="caerulus"
                  onChange={(checked) => {
                    if (checked) {
                      const params = [...filterOtherParams, service]
                      this.setState({
                        filterOtherParams: params,
                        filteredShops: this.filterList(allShops, filterParams, params)
                      })
                    } else {
                      const params = [...filterOtherParams]
                      params.splice(filterOtherParams.indexOf(service), 1)
                      this.setState({
                        filterOtherParams: params,
                        filteredShops: this.filterList(allShops, filterParams, params)
                      })
                    }
                  }}
                />
                <Translate value={service} />
              </label>
            </li>
          )}
          </ul>
        </Card>
      </div>
      { scene ?
      <div className="map-window">
        <Map
          locale={locale}
          zoom={scene.zoom}
          center={scene.location}
          locationName={scene.name[locale]}
          scenes={divingMode ? scene.scenes : filteredShops}
          aedList={showAed ? scene.aedList : []}
          divingMode={divingMode}
          selected={this.state.selected}
          clickHandler={divingMode ?
            (s360) => this.setState({ filtered: [s360], selected: s360.name[locale] }) :
            (shop) => {
              this.setState({
                filtered: _.filter(
                  _.map(activities, (activity, key) => ({...activity, id: key})),
                  (activity) => activity.shopId === shop.id),
                selected: shop.name[locale],
                selectedShop: shop
              })
            }
          }
          infoClickHandler={divingMode ? null :
            (shop) => navigate('/shop/' + shop.id)
          }
        />
        <div className="options clickable" onClick={() => this.setState({ divingMode: !divingMode, filtered: [] })}>
          { divingMode ? <div className="button">
              <Translate value="findShopAround" />
              <div className="icon-button">
                <i className="icon icon-xbig icon-marker-diving">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </div>
            </div> : <div className="button">
              <Translate value="find360Around" />
              <div className="icon-button">
                <i className="icon icon-xbig icon-marker-360">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                </i>
              </div>
            </div>
          }
        </div>
        <div className={"options clickable aux" + (showAed ? " active" : "")} onClick={() => this.setState({ showAed: !showAed })}>
          <div className="button">
            <Translate value={showAed ? "hideAED" : "showAED"} />
            <img src="/aed.png" alt="aed" />
          </div>
        </div>
        <div className="info-list">
          { divingMode ? 
            _.map(filtered, (s360) =>
              <Preview key={s360.name[locale]}
                locale={locale}
                subtitle={scene.name[locale]}
                data={s360}
                options={[{
                  isRating: true,
                  title: 'divingDifficulty',
                  emptySymbol: <div className="icon icon-rating-none" />,
                  fullSymbol: <div className="icon icon-rating" />,
                  value: s360.difficulty
                }, {
                  title: 'divingMethod',
                  value: s360.divingMethod && s360.divingMethod.split(',').map((method) => I18n.t(method)).join('、')
                }]}
                onClick={e => {
                  show360({ ...s360, location: scene.name })
                  e.stopPropagation()
                  e.preventDefault()
                }}
              />
            ) :
            <div className="stack">
              <div className="row">
                { selectedShop ? <Preview key={selectedShop.id}
                  locale={locale}
                  subtitle={scene.name[locale]}
                  data={selectedShop}
                  options={[
                    {
                      title: I18n.t('address'),
                      value: selectedShop.address[locale]
                    }
                  ]}
                  onClick={(e) => navigate('/shop/' + selectedShop.id)}
                /> : null}
              </div>
              <div className="list">
                {
                  _.map( filtered.length ? filtered : (!selectedShop && filteredDisplayActivities), (activity) => {
                    const comments = _.values(activity.comments)
                    return <Preview key={[activity.shopId, activity.name[locale]].join('-')}
                      locale={locale}
                      subtitle={scene.name[locale]}
                      data={activity}
                      options={[]}
                      footer={[{
                        isRating: true,
                        value: activity.rating
                      }, {
                        title: (comments ? comments.length : 0) + I18n.t('comments')
                      }, {
                        isButton: true,
                        title: I18n.t('seeDetail'),
                        onClick: (e) => navigate('/activity/' + activity.id)
                      }]}
                    />
                  } )
                }
                {
                  selectedShop && filtered.length === 0 &&
                  <div className="empty-card preview-container">{I18n.t('activity_coming_soon')}</div>
                }
              </div>
            </div>
          }
        </div>
      </div> : null }
    </div>
  }
}

const mapStateToProps = state => {
  return {
    locations: state.scene.locations,
    scene: state.scene.filtered,
    allShops: state.shop.shops,
    shops: state.shop.filtered,
    locale: state.i18n.locale,
    activities: state.activity.all,
    filteredActivities: state.activity.filtered,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    navigate: (location, args) => dispatch(push(location, args)),
    setViewScene: (scene) => dispatch(setViewScene(scene)),
    setViewShop: (shop) => dispatch(setViewShop(shop)),
    show360: (item) => dispatch(show360(item)),
    search: (location, startDate, endDate, experience) =>
      dispatch(search(location, startDate, endDate, experience)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MapMode)


// WEBPACK FOOTER //
// ./src/containers/MapMode/index.js